import { render, staticRenderFns } from "./VariationSizeComponent.html?vue&type=template&id=31758e78&"
import script from "./VariationSizeComponent.js?vue&type=script&lang=js&"
export * from "./VariationSizeComponent.js?vue&type=script&lang=js&"
import style0 from "./VariationSizeComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports